import { useEffect } from 'react';

export interface IUseMetaParams {
  title: string;
  description: string;
  keywords: string;
  url: string;
  image: string;
  noIndex: boolean;
  noImageIndex: boolean;
}

/**
 * Обновляет мету
 */
export const useMeta = ({ title, description, keywords, url, image, noIndex, noImageIndex }: IUseMetaParams) => {
  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    const metaKeywords = document.querySelector('meta[name="keywords"]') as HTMLMetaElement;
    const metaNoIndex = document.querySelector('meta[name="robots"]') as HTMLLinkElement;
    const ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
    const ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    const ogImage = document.querySelector('meta[property="og:image"]') as HTMLMetaElement;
    const ogDescription = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
    const twitterTitle = document.querySelector('meta[name="twitter:title"]') as HTMLMetaElement;
    const twitterImage = document.querySelector('meta[name="twitter:image"]') as HTMLMetaElement;
    const twitterDescription = document.querySelector('meta[name="twitter:description"]') as HTMLMetaElement;
    const linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    const robotsContentValues = Object.values({
      maxImagePreview: 'max-image-preview:large',
      noIndex: noIndex ? 'noindex' : undefined,
      noImageIndex: noImageIndex ? 'noimageindex' : undefined,
    }).filter(Boolean);

    document.title = title;

    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }

    if (!metaNoIndex) {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    metaNoIndex.setAttribute('content', robotsContentValues.length ? robotsContentValues.join(',') : 'all');

    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }

    if (ogUrl) {
      ogUrl.setAttribute('content', url);
    }

    if (ogImage) {
      ogImage.setAttribute('content', image || '');
    }

    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }

    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }

    if (twitterImage) {
      twitterImage.setAttribute('content', image || '');
    }

    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }

    if (!linkCanonical) {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    linkCanonical.setAttribute('href', url);
  }, [title, description, keywords, url, image, noIndex, noImageIndex]);
};
